import React from 'react';
import theme from 'source/theme';

export default ({ row, pcListOfProduct }) => {

  const productsToRender = row.productsInfo.map(product => product.name);
  const PC_product = {};

  pcListOfProduct.forEach(pc => {
    pc.productsInfo.forEach(product => {
      if (productsToRender.includes(product.name)) {
        PC_product[pc.descriptor_code] ?
          PC_product[pc.descriptor_code].push(product) :
          PC_product[pc.descriptor_code] = [product];
      }
    });
  });

  return <div style={{ backgroundColor: theme.palette.background.light }}>
    <ul style={{ margin: 0, paddingTop: 10, paddingBottom: 10 }}>
      {
        Object.keys(PC_product).map(pc =>
          <React.Fragment key={pc}>
            <li><strong>{pc}</strong></li>
            <ul style={{ margin: 0, paddingTop: 2, paddingBottom: 2 }}>
              {
                PC_product[pc].map(product =>
                  <li key={product.code}>{product.code + ' - ' + product.name}</li>
                )
              }
            </ul>
          </React.Fragment>
        )
      }
    </ul>
  </div>;
};


